import React from "react";

import { Connect } from "./Connect";
import { DropboxForm } from "./DropboxForm";

import { useDropbox } from "../../../providers/Dropbox";

export const Dropbox: React.FC = () => {
  const { isSignIn } = useDropbox();

  return isSignIn ? <DropboxForm /> : <Connect />;
};
